import { useNavigate, useParams } from "react-router-dom";
import { Empresa, EmpresaContext } from "./EmpresaContext";
import { ReactNode, useEffect, useState } from "react";
import api from "../../api/api";

interface Props { children: ReactNode; }

const EmpresaProvider = ({ children }: Props) => {
  const { empresa: slug } = useParams<{ empresa: string }>();
  const navigate = useNavigate();

  const [empresa, setEmpresa] = useState<Empresa | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;

    const storageKey = `empresa_${slug}`;
    const stored = localStorage.getItem(storageKey);

    if (stored) {
      getEmpresa(slug);
      //setEmpresa(JSON.parse(stored));
      setLoading(false);
    } else {
      getEmpresa(slug);
    }
  }, [slug]);

  const getEmpresa = async (slug: string) => {
    try {
      setLoading(true);

      const response = await api.get(`/empresa/${slug}`);
      const data = response.data;

      setEmpresa(data);
      localStorage.setItem(`empresa_${slug}`, JSON.stringify(data));

    } catch (e) {
      console.log(e);
      setEmpresa(null);
      navigate("/notFound");
    } finally {
      setLoading(false);
    }
  };

  return (
    <EmpresaContext.Provider value={{ empresa, loading }}>
      {children}
    </EmpresaContext.Provider>
  );
};

export default EmpresaProvider;